import { useState, useEffect } from 'react';
import { Redirect, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setMobileList } from 'redux/index';
import { getLifebooksChildren, getContributorChildren } from 'redux/selectors';
import { useSelectorListState } from 'helpers/hooks';
import useSetContributor from '../utils/useSetContributor';
import { useButtonArray } from '../utils/getButtons';
import ContributorBasicInfo from './ContributorBasicInfo';
import ContributorChildrenList from './ContributorChildrenList';
import { MobileHeader, PageLayout } from 'components';

const ManageContributor = ({
	basePath = '/contributors',
	caseManager = false,
}) => {
	const user = useSelector((state) => state.user.user);
	const isMd = useSelector((state) => state.mediaQuery.isMd);
	const dispatch = useDispatch();
	const childrenList = useSelector(getLifebooksChildren);
	const contributorChildren = useSelector(getContributorChildren);
	const casaChildren = useSelector((state) => state.casa.contributorChildren);
	const contributorHash = useSelector(
		(state) => state.contributor.contributorHash
	);
	const { contributorId } = useParams();
	const contributor = contributorHash[contributorId];

	const title = contributorId && contributor
		? `${contributor.firstname} ${contributor.lastname}`
		: 'Add Contributor';

	const [loaded, setLoaded] = useState(false);
	const [pageTitle, setPageTitle] = useState(title);

	useEffect(() => {
		setPageTitle(title);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [contributorHash]);

	useSetContributor({ setLoaded });
	const initialChildren =
		caseManager && !contributorId ? childrenList : contributorChildren;

	const childrenSelectorState = useSelectorListState(
		user.type === 'casauser' ? casaChildren : childrenList,
		initialChildren,
		{ loaded }
	);

	const getChildIds = () => {
		const { changes: { add, remove } = {} } = childrenSelectorState || {};

		const childIdsToAdd =
			caseManager && !contributorId
				? childrenSelectorState.assignedList.map(({ id }) => id)
				: add.map(({ id }) => id);
		const childIdsToRemove = remove.map(({ id }) => id);

		return { childIdsToAdd, childIdsToRemove };
	};

	const disabled =
		user.role === 'social-worker' && !user.privileged ? true : false;

	const buttonArray = disabled
		? null
		: useButtonArray(getChildIds, basePath, caseManager);

	if (contributorId && !contributor) {
		return <Redirect to={`${basePath}/`} />;
	}

	return (
		<PageLayout
			title={pageTitle}
			buttonArray={buttonArray}
			align='left'
			header={
				caseManager && isMd ? (
					<MobileHeader onNavBack={() => dispatch(setMobileList(true))} />
				) : undefined
			}>
			<ContributorBasicInfo key={contributorId} disabled={disabled} />
			<ContributorChildrenList
				disabled={disabled}
				disableRemove={caseManager}
				locked={caseManager}
				key={contributorId + 1}
				selectorListState={childrenSelectorState}
			/>
		</PageLayout>
	);
};

export default ManageContributor;
